import {
    GET_PRODUCT,
    GET_PRODUCT_SUCCESS,
    GET_PRODUCT_FAILURE,
    UPDATE_PRODUCT_STATUS,
    UPDATE_PRODUCT_STATUS_SUCCESS,
    UPDATE_PRODUCT_STATUS_FAILURE,
    ADD_PRODUCT,
    ADD_PRODUCT_SUCCESS,
    ADD_PRODUCT_FAILURE,
    EDIT_PRODUCT,
    EDIT_PRODUCT_SUCCESS,
    EDIT_PRODUCT_FAILURE,
    DELETE_PRODUCT,
    DELETE_PRODUCT_SUCCESS,
    DELETE_PRODUCT_FAILURE,
    UPDATE_PRODUCT_ORDER_STATUS,
    UPDATE_PRODUCT_ORDER_STATUS_SUCCESS,
    UPDATE_PRODUCT_ORDER_STATUS_FAILURE
} from "../Constants";

const init = {
    data: {},
    status_data: {},
    add_data: {},
    edit_data: {},
    delete_data: {},
    order_status_data: {}
};

const ProductReducer = (state = init, action) => {
    switch (action.type) {
        case GET_PRODUCT:
            return { ...state, loading: true };
        case GET_PRODUCT_SUCCESS:
            return { ...state, loading: false, data: action.payload };
        case GET_PRODUCT_FAILURE:
            return { ...state, loading: false, data: action.payload };
        case UPDATE_PRODUCT_STATUS:
            return { ...state, loading: true };
        case UPDATE_PRODUCT_STATUS_SUCCESS:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_PRODUCT_STATUS_FAILURE:
            return { ...state, loading: false, status_data: action.payload };
        case UPDATE_PRODUCT_ORDER_STATUS:
            return { ...state, loading: true };
        case UPDATE_PRODUCT_ORDER_STATUS_SUCCESS:
            return { ...state, loading: false, order_status_data: action.payload };
        case UPDATE_PRODUCT_ORDER_STATUS_FAILURE:
            return { ...state, loading: false, order_status_data: action.payload };
        case ADD_PRODUCT:
            return { ...state, loading: true };
        case ADD_PRODUCT_SUCCESS:
            return { ...state, loading: false, add_data: action.payload };
        case ADD_PRODUCT_FAILURE:
            return { ...state, loading: false, add_data: action.payload };
        case EDIT_PRODUCT:
            return { ...state, loading: true };
        case EDIT_PRODUCT_SUCCESS:
            return { ...state, loading: false, edit_data: action.payload };
        case EDIT_PRODUCT_FAILURE:
            return { ...state, loading: false, edit_data: action.payload };
        case DELETE_PRODUCT:
            return { ...state, loading: true };
        case DELETE_PRODUCT_SUCCESS:
            return { ...state, loading: false, delete_data: action.payload };
        case DELETE_PRODUCT_FAILURE:
            return { ...state, loading: false, delete_data: action.payload };
        default:
            return state;
    }
};

export default ProductReducer;